import * as React from "react";
import {Dropdown} from "semantic-ui-react";

export const SimpleDropdown = (props) => (
    <Dropdown {...props}
              onChange={(event, data) => props.onValueChanged && props.onValueChanged(data.value)}
    />
);


// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/SImpleDropdown.jsx